export default __webpack_public_path__ + "static/savjetiImg-47476fa648f4cfef6035add74b5ff94c.jpg";